module.exports = __webpack_public_path__ + "static/media/Junghunde01.8450f1d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Junghunde01.jpg
// module id = 333
// module chunks = 0